<template>
  <svg
    height="18px" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;" version="1.1"
    viewBox="0 0 126 121" width="18px"
    xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:serif="http://www.serif.com/"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g>
      <path
        :style="fillStyle.yellow"
        d="M0,58.504l12.985,-36.587l31.921,-21.917l38.664,1.123l30.639,23.734l10.911,37.281l-12.984,36.586l-31.92,21.917l-38.665,-1.123l-30.639,-23.735l-10.912,-37.279Z"
      />
      <path
        :style="fillStyle.yellow"
        d="M12.985,21.918l-12.985,36.586l10.911,37.28l30.64,23.734l38.665,1.123l-35.31,-120.641l-31.921,21.918Z"
      />
      <path
        :style="fillStyle.red"
        d="M114.209,24.857l-51.648,35.464l62.56,1.817l-10.912,-37.281Z"
      />
      <path
        :style="fillStyle.red"
        d="M62.56,60.321l21.01,-59.199l-38.664,-1.122l17.654,60.321Z"
      />
      <path
        :style="fillStyle.red"
        d="M112.136,98.724l-49.575,-38.404l17.655,60.321l31.92,-21.917Z"
      />
      <path
        :style="fillStyle.red"
        d="M12.985,21.918l49.575,38.403l-62.56,-1.817l12.985,-36.586Z"
      />
      <path
        :style="fillStyle.red"
        d="M10.912,95.784l51.648,-35.463l-21.009,59.197l-30.639,-23.734Z"
      />
      <path
        d="M63.812,64.596c-2.35,0.693 -4.816,-0.66 -5.508,-3.021c-0.69,-2.362 0.655,-4.838 3.005,-5.53c2.351,-0.693 4.816,0.661 5.508,3.022c0.691,2.361 -0.654,4.837 -3.005,5.529"
        style="fill:#fff;fill-rule:nonzero;"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    fillStyle: Object,
  },
};
</script>
